import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPaymentPlanStatus: false,
};

export const DeleteSchedulePlanSlice = createSlice({
  name: 'DeleteSchedulePlan',
  initialState,
  reducers: {
    DeleteSchedulePlan: (state) => {
     // console.log("actinon called")
      state.currentPaymentPlanStatus = !state.currentPaymentPlanStatus; // Toggle the currentPaymentPlanStatus
    },
  },
});

export const { DeleteSchedulePlan } = DeleteSchedulePlanSlice.actions;
export default DeleteSchedulePlanSlice.reducer;